import React from 'react';
import IconButton from '../../../ui/IconButton';

const MENU_ACTIONS = [
  { id: 'appearance', label: 'Appearance' },
  { id: 'wiki', label: 'Wiki', href: '/wiki' },
  { id: 'profile', label: 'Profile' },
  { id: 'password', label: 'Change Password' },
  { id: 'email', label: 'Update Email' },
  { id: 'hall', label: 'Hall of Fame' },
  { id: 'logout', label: 'Logout', className: 'game-menu__item--logout' },
];

const GameMenu = React.memo(function GameMenu({
  embedded = false,
  isOpen,
  onToggle,
  onAction,
  menuRef,
}) {
  const closeWithKeyboard = event => {
    if (!isOpen || event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.querySelector('.game-menu__toggle')?.focus();
    onToggle();
  };

  return (
    <div
      aria-label="Player menu"
      className={`game-menu${embedded ? ' game-menu--embedded' : ''}`}
      data-floating-window-obstacle={embedded ? undefined : 'true'}
      onKeyDown={closeWithKeyboard}
      ref={menuRef}
      role="group"
    >
      <IconButton
        className="game-menu__toggle"
        icon="menu"
        label={isOpen ? 'Close player menu' : 'Open player menu'}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls="player-menu-dropdown"
      />
      <div
        id="player-menu-dropdown"
        className={`game-menu__dropdown ${isOpen ? 'is-open' : ''}`}
        data-floating-window-obstacle={isOpen ? 'true' : undefined}
        hidden={!isOpen}
      >
        <ul className="game-menu__list">
          {MENU_ACTIONS.map(action => (
            <li key={action.id}>
              {action.href ? (
                <a
                  className={`game-menu__item ${action.className ?? ''}`.trim()}
                  href={action.href}
                  onClick={() => onAction(action.id)}
                >
                  {action.label}
                </a>
              ) : (
                <button
                  type="button"
                  className={`game-menu__item ${action.className ?? ''}`.trim()}
                  onClick={() => onAction(action.id)}
                >
                  {action.label}
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});

export default GameMenu;
